<template>
    <div
        class="tags"
        v-if="showTags">
        <ul>
            <li
                class="tags-li"
                v-for="(item,index) in tagsList"
                :class="{'active': isActive(item.path)}"
                :key="index">
                <router-link
                    class="tags-li-title"
                    :to="item.path">
                    {{item.title}}
                </router-link>
                <span
                    class="tags-li-icon"
                    @click="closeTags(index)">
                    <i class="el-icon-close"></i>
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import tags from './tags.js';

export default {
    ...tags
};
</script>
<style src="./tags.css" scoped></style>



// WEBPACK FOOTER //
// src/views/common/tags/tags.vue